import {currentSessionToken,rpcRequest} from './supabaseGateway';
import type { CommunityRole, LibraryCreateInput, LibraryItem, LibraryKind, LibrarySource } from './types';

const KINDS:LibraryKind[]=['text','audio','video','pdf','image','link','meditation','collection'];

function validRole(value:unknown):CommunityRole{
 if(value==='owner'||value==='admin'||value==='moderator'||value==='member'||value==='guest')return value;
 throw new Error('Ungültige Raumrolle.');
}
function rpc<T>(name:string,args:Record<string,unknown>):Promise<T>{
 return rpcRequest<T>(name,args,'Die Bibliothek konnte nicht geladen werden.');
}
function parseItem(value:unknown):LibraryItem{
 if(!value||typeof value!=='object')throw new Error('Bibliotheksinhalt ist ungültig.');
 const item=value as Record<string,unknown>;
 if(typeof item.id!=='string'||typeof item.title!=='string'||typeof item.created_at!=='string'||typeof item.updated_at!=='string')throw new Error('Bibliotheksinhalt ist unvollständig.');
 const spaces=Array.isArray(item.spaces)?item.spaces.flatMap(raw=>{
  if(!raw||typeof raw!=='object')return[];
  const room=raw as Record<string,unknown>;
  if(typeof room.id!=='string'||typeof room.slug!=='string'||typeof room.title!=='string')return[];
  return[{id:room.id,slug:room.slug,title:room.title,role:validRole(room.role)}];
 }):[];
 return{
  source_type:item.source_type==='legacy'?'legacy':'native',id:item.id,
  kind:KINDS.includes(item.kind as LibraryKind)?item.kind as LibraryKind:'text',title:item.title,
  excerpt:typeof item.excerpt==='string'?item.excerpt:'',body:typeof item.body==='string'?item.body:'',
  external_url:typeof item.external_url==='string'?item.external_url:null,mime_type:typeof item.mime_type==='string'?item.mime_type:null,
  duration_seconds:typeof item.duration_seconds==='number'?item.duration_seconds:null,status:typeof item.status==='string'?item.status:'published',
  visibility:typeof item.visibility==='string'?item.visibility:'inherited',publish_at:typeof item.publish_at==='string'?item.publish_at:null,
  created_at:item.created_at,updated_at:item.updated_at,metadata:item.metadata&&typeof item.metadata==='object'&&!Array.isArray(item.metadata)?item.metadata as Record<string,unknown>:{},
  featured:item.featured===true,favorite:item.favorite===true,can_manage:item.can_manage===true,spaces,
  media_owner_type:item.media_owner_type==='community_content'?'community_content':'library',media_owner_id:typeof item.media_owner_id==='string'?item.media_owner_id:item.id,
 };
}

export async function loadLibrary(spaceSlug:string|null=null,filter='all'):Promise<LibraryItem[]>{
 const data=await rpc<{items?:unknown[]}>('community_library_read',{p_token:currentSessionToken(),p_space_slug:spaceSlug,p_filter:filter});
 return(data.items||[]).map(parseItem);
}
async function action<T=unknown>(name:string,payload:Record<string,unknown>):Promise<T>{
 return rpc<T>('community_library_manage',{p_token:currentSessionToken(),p_action:name,p_payload:payload});
}
export async function createLibraryItem(input:LibraryCreateInput):Promise<LibraryItem>{
 const result=await action<{content:unknown}>('create',input as unknown as Record<string,unknown>);
 const raw=result.content as Record<string,unknown>;
 return parseItem({...raw,source_type:'native',featured:Boolean(input.featured),favorite:false,can_manage:true,spaces:input.space_slugs.map(slug=>({id:slug,slug,title:slug,role:'owner'})),media_owner_type:'community_content',media_owner_id:raw.id});
}
export async function updateLibraryItem(id:string,payload:Record<string,unknown>){await action('update',{id,...payload});}
export async function archiveLibraryItem(id:string){await action('archive',{id});}
export async function setLibraryFavorite(source:LibrarySource,id:string,favorite:boolean){await action(favorite?'favorite':'unfavorite',{source_type:source,id});}
export async function linkLibraryItem(source:LibrarySource,id:string,spaceSlug:string){await action(source==='legacy'?'legacy_link':'link',{id,space_slug:spaceSlug});}
export async function unlinkLibraryItem(source:LibrarySource,id:string,spaceSlug:string){await action(source==='legacy'?'legacy_unlink':'unlink',{id,space_slug:spaceSlug});}
